import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { QAlert, QBox, useCurrentUser } from '@qualio/ui-components';

import { DocumentOverviewContext } from '../../Context';
import { shouldRenderCompleteTraining } from '../../RenderLogic';

export const TrainingAlert = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { qualioDocument, currentEditorMode } = useContext(
    DocumentOverviewContext,
  );
  if (
    !shouldRenderCompleteTraining(
      qualioDocument,
      currentUser,
      currentEditorMode,
    )
  ) {
    return null;
  }

  return (
    <QBox paddingBottom={4}>
      <QAlert
        title={t('messages.youHaveTrainingOutstanding')}
        description={t('messages.pleaseCompleteTrainingByReading')}
        status="info"
      />
    </QBox>
  );
};
